/** 낭만월운 > 목차 */
export const CONTENTS = [
  { id: 1, title: '📖 낭만월운 안내서' },
  { id: 2, title: '' },
  { id: 3, title: '1. 이달의 총운' },
  { id: 4, title: '2. 이달의 애정운' },
  { id: 5, title: '3. 이달의 재물운' },
  { id: 6, title: '4. 이달의 건강운' },
  { id: 7, title: '5. 이달의 나를 위한 개운법' },
];

/** 낭만월운 > 페이지네이션 > 목차 인덱스 - 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1, // 첫 번째 가이드 페이지
  1: 2, // 두 번째 가이드 페이지
  2: 3, // 첫 번째 컨텐츠 페이지
  3: 4,
  4: 5,
  5: 6,
  6: 7,
};
